var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 43.0835C7.83301 38.9284 9.4836 34.9436 12.4217 32.0055C15.3597 29.0674 19.3446 27.4168 23.4997 27.4168C27.6547 27.4168 31.6396 29.0674 34.5777 32.0055C37.5158 34.9436 39.1663 38.9284 39.1663 43.0835H7.83301ZM25.458 31.496V39.1668H34.5819C33.8818 37.1917 32.667 35.4393 31.0631 34.0907C29.4591 32.7422 27.5241 31.8464 25.458 31.496V31.496ZM21.5413 39.1668V31.496C19.4753 31.8464 17.5403 32.7422 15.9363 34.0907C14.3323 35.4393 13.1175 37.1917 12.4175 39.1668H21.5413ZM23.4997 25.4585C17.0078 25.4585 11.7497 20.2004 11.7497 13.7085C11.7497 7.21662 17.0078 1.9585 23.4997 1.9585C29.9916 1.9585 35.2497 7.21662 35.2497 13.7085C35.2497 20.2004 29.9916 25.4585 23.4997 25.4585ZM23.4997 21.5418C27.8276 21.5418 31.333 18.0364 31.333 13.7085C31.333 9.38058 27.8276 5.87516 23.4997 5.87516C19.1718 5.87516 15.6663 9.38058 15.6663 13.7085C15.6663 18.0364 19.1718 21.5418 23.4997 21.5418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.e65975730858488968b1416ef289fb78.svg";
export { ForwardRef as ReactComponent };